import { Pipe, PipeTransform } from '@angular/core';
import { ImageBreakpoint } from '../types/product-images.const';
import { Observable, map } from 'rxjs';
import { PlatformService } from '../services/platform.service';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'productImage',
})
export class ProductImagePipe implements PipeTransform {
  public readonly imagesBaseUrl: string;

  constructor(private readonly platformService: PlatformService) {
    this.imagesBaseUrl = environment.imagesUrl;
  }

  transform(
    imageUrl: string,
    specificBreakpoint?: ImageBreakpoint
  ): Observable<string> {
    return this.platformService.screenWidth$.pipe(
      map((screenWidth) => {
        const neededBreakpoint =
          specificBreakpoint || this.getBreakpointByWidth(screenWidth);
        return `${this.imagesBaseUrl}${imageUrl}?size=${neededBreakpoint}`;
      })
    );
  }

  getBreakpointByWidth(width: number): ImageBreakpoint {
    if (width <= ImageBreakpoint.SMALL) {
      return ImageBreakpoint.SMALL;
    }
    if (width > ImageBreakpoint.SMALL && width <= ImageBreakpoint.MEDIUM) {
      return ImageBreakpoint.MEDIUM;
    }
    return ImageBreakpoint.LARGE;
  }
}
